<div class="subpage-slider vertical-center" [style.background-image]="'url(/assets/images/referral/' + (projectCode === 'qp11-dark' ? 'sb-referrals-' + languageCode() : 'sb-referrals') + '.jpg)'">
  @if (projectCode !== 'qp11-dark') {
    <div class="subpage-title-promotion">
      <p [ngStyle]="{ 'color': isQP2D ? '#232425' : '' }">{{ (activeGameCategoryTab() ? activeGameCategoryTab().name : (!isQP20 ? ('Referral' | translate) : '推荐好友')) | uppercase }}</p>
    </div>
  }

  <!-- Hide the banner and show skeleton first until the banner image finishes loading -->
  @if (!bannerLoaded()) {
    <div class="skeleton-banner skeleton-banner-box">
      <div class="skeleton skeleton-banner"></div>
    </div>
  }
</div>

<section id="content">
  <div class="section my-0 p-t-65" [class.m-t-0]="userData()?.KYC != 'pro' && isLoggedIn()">
    <div class="container">
      <div class="row p-t-50">
        <div class="col-6 p-l-0 referral-content">
          @if (referralData() && !isSkeletonReferralData()) {
            <h2 [innerHtml]="referralData().title"></h2>
            <p [innerHtml]="referralData().description"></p>
          } @else if (isSkeletonReferralData()) {
            @for (item of [].constructor(2); track $index) {
              <h2 class="skeleton skeleton-title ml-0"></h2>
            }
            <div class="mt-3">
              @for (item of [].constructor(6); track $index) {
                <p class="skeleton skeleton-text"></p>
              }
            </div>
          }

          @if (isLoggedIn()) {
            <div class="row m-t-20 m-b-70">
              @if (details() && !isSkeletonDetails()) {
                <div class="qr-code-container">
                  <div>
                    <qrcode #qrCode [qrdata]="getQRSignupLink(details().referral_code)" [margin]="1" [width]="150"></qrcode>
                  </div>
                  <button class="referral-qr-btn" (click)="onDownloadQR(qrCode)">{{ 'Download' | translate | uppercase }}</button>
                </div>

                <div class="referral-code-section">
                  <div class="col-12">
                    <p>{{ 'Referral Code' | translate }}</p>
                  </div>
                  <div class="referral-code-col">
                    <div class="col-9 p-r-0">
                      <div class="input-with-icon input_container">
                        <span (click)="onCopyText(referralCodeInput, 'code')" class="copy-input">
                          <input type="text" class="form-control form-control-sm form-input-style with-copy"
                            [value]="details() ? details().referral_code : ''" readonly #referralCodeInput [innerHTML]="svg.copyIcon | safeHtml">
                          <span class="input-group-append" [innerHTML]="svg.copyIcon | safeHtml" (mouseenter)="$event.stopImmediatePropagation()" (mouseleave)="$event.stopImmediatePropagation()"
                            mat-raised-button #tooltipCode="matTooltip" matTooltip="{{ 'Copied' | translate }}"
                            matTooltipPosition="above">
                          </span>
                        </span>
                      </div>
                    </div>
                    <div class="col-3">
                      <button class="main-button-1" [disabled]="loading()" (click)="onShare()">{{ 'SHARE' | translate }}</button>
                    </div>
                  </div>
                </div>
              } @else if (isSkeletonDetails()) {
                <div class="col-12 m-b-20">
                  <p class="skeleton skeleton-text w-25"></p>
                </div>
                <div class="col-9 p-r-0">
                  <div>
                    <span>
                      <input type="text" class="form-control form-control-sm form-input-style with-copy border-0 skeleton skeleton-referral-code ">
                    </span>
                  </div>
                </div>
                <div class="col-3">
                  <input type="text" class="form-control form-control-sm form-input-style with-copy border-0 skeleton skeleton-referral-code ">
                </div>
              }
            </div>
          } @else {
            <div class="row">
              <div class="col-12 referral-content">
                <div class="referral-detail m-t-30" (click)="onJoinNow()">
                  <span><h3>{{ 'Join Now' | translate | uppercase }}</h3></span>
                  <span>{{ 'Join us to start your Referral Journey by completing simple registration and sharing among your friends!' | translate }}</span>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="col-6 referral-content">
          <img src="assets/images/referral/referral-side-banner.png">
        </div>
      </div>
      @if (projectCode == 'qp15' || projectCode == 'qp8' || projectCode == 'qp18' || (domainEnv == 'demo' && projectCode == 'qp2a')) {
        @if ((countryCode() !== 'IN' && languageCode() == 'en') || languageCode() == 'bn') {
          <div class="row p-t-50">
            <img class="w-100" src="assets/images/referral/{{ languageCode() }}/content-1.png">
          </div>

          <div class="row p-t-50 referral-tnc">
            <h6 class="font-weight-700">{{ 'Terms & Conditions' | translate | uppercase }}</h6>
            <ol>
              <li>{{ 'This Referral Program is applicable for all players.' | translate }}</li>
              <li>{{ 'The accumulation of commission will starts from 12:00 AM (GMT+6) to 11:59 PM (GMT+6) everyday.' | translate }}</li>
              <li>{{ 'Once the accumulation is done, the commission release will start from 12:05 PM (GMT+6) everyday.' | translate }}</li>
              <li>{{ 'Agents have to fulfill the 1x Turnover requirement in order to submit the withdrawal request.' | translate }}</li>
              <li>{{ 'Duplication of accounts in an address is prohibited. Sharing of the same address, IP address, email address, phone number, credit/debit cars, and/or shared devices (such as school, public library, or workplace) are not allow to claim more than 10 times.' | translate }}</li>
              <li>{{ 'Any bets that results in a void, tie, cancellation, or the opposite outcome will not be counted towards the turnover requirement of DC 1.5 or CN 1.5.' | translate }}</li>
              <li>{{ 'Roulette games are only allowed to place 1/4 of the numbers and FanTan games are allowed to place only 1/2 numbers. Crazy Time only allows for bet 6 places.' | translate }}</li>
              <li>{{ 'SicBo and BacBo are not allowed to play if members claimed this bonus.' | translate }}</li>
              <li>{{ 'Participants must adhere to all the terms and conditions mentioned about and all relevant rules and regulations described on the [site_name] website.' | translate: { site_name : siteName } }}</li>
              <li>{{ '[site_name] reserves the right to freeze/block accounts of members for any suspicious or fraudulent activities investigation.' | translate: { site_name : siteName } }}</li>
              <li>{{ '[site_name] reserves thee right to confiscate all the winning/bonus from any customer or group of customers if found to be a breach of any clause at any time and at our sole and absolute discretion.' | translate: { site_name : siteName } }}</li>
              <li>{{ '[site_name] reserves the right to change, cancel or suspend the terms and conditions of this promotion at any time without prior notice.' | translate: { site_name : siteName } }}</li>
            </ol>
            <p class="mt-4 mb-0">{{ 'General [site_name] Terms & Conditions apply.' | translate: { site_name : siteName } }}</p>
          </div>
          <div class="row p-t-50">
            <img class="w-100" src="assets/images/referral/{{ languageCode() }}/content-2.png">
          </div>
        }
      }
    </div>
  </div>
</section>
